import { BaseErrorLayout } from '@dvb/ui';
import { Button } from '@heroui/react';
import { useAuthStore } from '@milestone-portal/context/useAuthStore';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * Navigate to setting instead of home is because setting do not involve any data fetching,
 * it should be the most stable page.
 */
export function DefaultError() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authData } = useAuthStore();

  const handleNavigate = () => {
    if (!authData?.user) {
      navigate({
        to: '/',
      });
      return;
    }

    navigate({
      to: '/profile',
    });
  };

  return (
    <BaseErrorLayout
      actionElement={<Button onPress={handleNavigate}>{t('profile')}</Button>}
      className="bg-background w-full"
    />
  );
}
